import { useEffect, useState } from 'react';
import pusher from '../services/notification/pusher';
import useAuthContext from './useAuthContext';

/* const publicChannel = {
  channelName: 'notification',
  eventName: 'notification',
}; */

const privateEventsName = ['notification']; // por si se necesitan mas eventos privados (lo dudo, se manejan por type en la data)

const usePusher = () => {
  const [data, setData] = useState(null);
  const { user, isAuthenticated } = useAuthContext();

  useEffect(() => {
    if (!isAuthenticated) return;
    const privateChannel = pusher.subscribe(`App.Models.User.${user.id}`);
    const privateEvents = privateEventsName.map((name) =>
      privateChannel.bind(name, (notif) => {
        setData(notif);
      }),
    );

    return () => {
      privateEvents.forEach((event) => event.unbind());
      if (isAuthenticated) pusher.unsubscribe(`App.Models.User.${user.id}`);
    };
  }, [isAuthenticated]);

  return data;
};

export default usePusher;
